module.exports = {
    SECRET_TOKEN : 'ALL_YOU_NEED_IS_LOVE'
}